/**
 * Persists the notary dashboard choice « Dossiers invités » across folder detail and sub-routes
 * (session tab). Cleared on « Dossiers de l'office », logout, or explicit clear.
 */

const STORAGE_KEY = "lecoffre_notary_invited_folders_nav_active";

export function getNotaryInvitedFoldersNavActive(): boolean {
	if (typeof window === "undefined") {
		return false;
	}
	return window.sessionStorage.getItem(STORAGE_KEY) === "1";
}

export function setNotaryInvitedFoldersNavActive(active: boolean): void {
	if (typeof window === "undefined") {
		return;
	}
	if (active) {
		window.sessionStorage.setItem(STORAGE_KEY, "1");
	} else {
		window.sessionStorage.removeItem(STORAGE_KEY);
	}
}

export function clearNotaryInvitedFoldersNavActive(): void {
	setNotaryInvitedFoldersNavActive(false);
}

/**
 * Paths where persisted « invited » context should keep sidebar / back behaviour
 * (folder workspace, excluding list-only routes like /folders/shared handled elsewhere).
 */
export function pathnameEligibleForPersistedInvitedNav(pathname: string): boolean {
	if (!pathname) {
		return false;
	}
	const parts = pathname.split("/").filter(Boolean);
	if (parts.length < 2 || parts[0] !== "folders") {
		return false;
	}
	const first = parts[1];
	if (first === "shared") {
		return false;
	}
	if (first === "deleted" || first === "create" || first === "select") {
		return false;
	}
	if (first === "archived") {
		return parts.length >= 3;
	}
	return true;
}
